import { Denomination } from "./Denomination";
import { StockTypeEnum } from "./enums/StockTypeEnum";

export class Stock {
    index: number = -1;
    cashIn: boolean = false;
    exceed: boolean = false;
    unfit: boolean = false;
    counterfit: boolean = false;
    suspect: boolean = false;
    denominations: Denomination[];
    stockType: StockTypeEnum;

    public parse(obj: any) {
        if (obj.Index != null && obj.Index != undefined) this.index = obj.Index;
        if (obj.CashIn) this.cashIn = obj.CashIn;
        if (obj.Exceed) this.exceed = obj.Exceed;
        if (obj.Unfit) this.unfit = obj.Unfit;
        if (obj.Counterfit) this.counterfit = obj.Counterfit;
        if (obj.Suspect) this.suspect = obj.Suspect;
        if (obj.Denominations && obj.Denominations.length > 0) {
            this.denominations = [];
            obj.Denominations.forEach((e) => {
                var d: Denomination = new Denomination();
                d.parse(e);
                this.denominations.push(d);
            });
        }
        if (obj.StockType) this.stockType = obj.StockType;
    }
}
